import { LocalStorageKey } from 'src/config/constants';
import { createStore, useStore } from 'src/utils/createStore';
import {
  SESSION_SCOPE,
  getInLocalStorageByKey,
  readStoredItem,
  setInLocalStorage,
  writeStoredItem,
} from 'src/utils/storageManager';

const PROFILE_CHOSEN_KEY = 'baobab_profile_chosen';

// sessionStorage dies with the WebView process, so the choice is asked again after a real kill only.
const profileChosen = createStore(
  readStoredItem(PROFILE_CHOSEN_KEY, SESSION_SCOPE) === 'true',
);

const isDeviceShared = createStore(
  getInLocalStorageByKey(LocalStorageKey.IS_SHARED_DEVICE) === true,
);

const setDeviceShared = (isShared: boolean) => {
  setInLocalStorage(LocalStorageKey.IS_SHARED_DEVICE, isShared);
  isDeviceShared.setState(isShared);
};

export const forgetSharedDevice = () => setDeviceShared(false);

export const markProfileChosen = () => {
  writeStoredItem(PROFILE_CHOSEN_KEY, 'true', SESSION_SCOPE);
  profileChosen.setState(true);
};

// Whoever marks the phone as shared is using it now: the choice comes at the next launch.
export const markDeviceShared = () => {
  markProfileChosen();
  setDeviceShared(true);
};

export const useIsProfileChoiceNeeded = () => {
  const isChosen = useStore(profileChosen);
  const isShared = useStore(isDeviceShared);
  return !isChosen && isShared;
};
